import React, { useEffect } from 'react'
import './index.less'
import { Form, Input, InputNumber } from 'antd'
import RowHeader from '../RowHeader'
import PortItem from './PortItem'

type ExperPortsProps = {
    initValue?: any
}

const ExperPorts: React.FC<ExperPortsProps> = (props) => {

    const { initValue } = props

    const form = Form.useFormInstance()

    useEffect(() => {
        form.setFieldsValue({
            port: initValue?.port == undefined ? '' : String(initValue?.port),
            name: initValue?.name,
            image: initValue?.image
        })
    }, [initValue])


    return (
        <div className='ExperPorts' style={{marginBottom: '16px'}}>
            <Form.Item
                label='端口号'
                name='port'
                rules={[
                    { required: true, message: '请输入端口号', validateTrigger: "onSubmit", whitespace: true },
                    {
                        validator(_, value: number) {
                            const re = /^(?:[1-9]\d{0,3}|[1-2]\d{4}|30000)$/
                            if (!re.test(value + '')) {
                                return Promise.reject('请输入1-30000的数字')
                            }
                            return Promise.resolve()
                        }, validateTrigger: "onSubmit"
                    }
                ]}
                labelCol={{ span: 3 }}
                validateFirst
            >
                <Input style={{ width: '100%' }} placeholder='请输入端口号' allowClear />
            </Form.Item>
            <Form.Item
                label='端口名称'
                name='name'
                rules={[
                    { required: true, message: '请输入端口名称', validateTrigger: "onSubmit", whitespace: true },
                    {
                        validator(_, value: string) {
                            const re = /^[\u4E00-\u9FA5a-zA-Z0-9_-]+$/
                            if (!re.test(value)) {
                                return Promise.reject(new Error('请输入3-20字符的中英文、数字、_-'))
                            }
                            return Promise.resolve()
                        }, validateTrigger: "onSubmit"
                    }
                ]}
                validateFirst
            >
                <Input showCount maxLength={10} allowClear placeholder='请输入端口名称' />
            </Form.Item>
            <Form.Item
                label='端口图标'
                name='image'
                rules={[
                    { required: true, message: '请选择端口图标', validateTrigger: "onSubmit", whitespace: true },
                ]}
                validateFirst
            >
                <PortItem />
            </Form.Item>
        </div>
    )
}

export default ExperPorts